import { QueryFactory } from "../../../../Common";
export const QGetLeaderboards = QueryFactory("GetLeaderboards");
//# sourceMappingURL=QGetLeaderboards.js.map